<script>
    import { PATH_PREFIX } from '../../../apiUrls.js';
    import { sgettext } from '../../../i18n.js';

    import TypeBadge from "../../DashBoard/TypeBadge.svelte";
    import ImageTextCellRenderer from "./ImageTextCellRenderer.svelte";

    export let name;
    export let sequenceName;
    export let element_instances;
    export let sequenceRowSpan;
    export let roleIndex;
    export let sequenceIndex;
    export let activityVersionId;
    

    const getRiskOrControlImage = item => item?.icon ? item.icon.url : '';

    const getMechanismImage = mechanism => mechanism.energy_type?.icon ? mechanism.energy_type.icon.url : '';

    const getRRRStyle = rrr => {
      if (!rrr) return {};
      return +rrr > 30
        ? "color: #FFFFFF; background-color: #D32F2F;"
        : "color: #000000; background-color: #81C784;"
    }

    const getBackground = (invalid, confirmed) => invalid ? "background-color: #fcd2d7;" : confirmed ? "" : "background-color: #FAE6E8;";

    const getInvalidTooltip = (invalid, confirmed) => {
        if (invalid) return sgettext('$$INVALID_RISK_CONTROL_COMBINATION$$');
        if (!confirmed) return sgettext("$$CONFIRM_RRR_BUILDER_VIEW$$");
    }

</script>

{#each element_instances as { element_id, step, type, name: elementName, risks_and_controls, elementRowSpan, expired, work_sequence_id }, elementIndex}
  {#if !expired}
    {#each risks_and_controls as { global_hazard, global_control, mechanism, severity, likelihood, rrr, confirmed, invalid }, riskIndex}
      <tr>
        {#if elementIndex === 0 && riskIndex === 0}
          <td rowspan={sequenceRowSpan}>
            <div class="label-container">
              <div class="text">
                {sequenceName}
              </div>
            </div></td
          >
        {/if}

        {#if riskIndex === 0}
          <td rowspan={elementRowSpan}>{step + 1}</td>
          <td rowspan={elementRowSpan}><TypeBadge data={type} /></td>
          <td rowspan={elementRowSpan}>
            <a
              href={`${PATH_PREFIX}/sw/builder/activity_sequence_builder/${activityVersionId}/worksequence/${work_sequence_id}/element_instance/${element_id}/`}
              target="_blank" rel="noopener noreferrer">{elementName}</a
            >
          </td>
        {/if}

        <td
          class={invalid ? 'red-border-left' : ''}
          style={getBackground(invalid, confirmed)}
        >
          <ImageTextCellRenderer
            imageSrc={getMechanismImage(mechanism)}
            mainText={mechanism.energy_type.name}
            subText={mechanism.name}
            altText={mechanism.name}
            invalid={!confirmed || invalid}
            invalidTooltip={getInvalidTooltip(invalid, confirmed)}
          />
        </td>
        <td
          class={invalid ? 'red-border' : ''}
          style={getBackground(invalid, confirmed)}
        >
          <ImageTextCellRenderer
            imageSrc={getRiskOrControlImage(global_hazard)}
            mainText={global_hazard.name}
            subText={global_hazard.description}
            altText={global_hazard.name}
          />
        </td>
        <td
          class={invalid ? 'red-border-right' : ''}
          style={getBackground(invalid, confirmed)}
        >
          <ImageTextCellRenderer
            imageSrc={getRiskOrControlImage(global_control)}
            mainText={global_control.name}
            subText={global_control.description}
            altText={global_control.name}
          />
        </td>

        <td>{confirmed ? severity : ''}</td>
        <td>{confirmed ? likelihood : ''} </td>
        <td style={confirmed ? getRRRStyle(rrr) : ''}>{confirmed ? rrr : ''}</td
        >
      </tr>
    {/each}
  {/if}
{/each}

<style>
  .red-border {
    border-top: 2px solid red;
    border-bottom: 2px solid red;
  }

  .red-border-left {
    border-top: 2px solid red;
    border-bottom: 2px solid red;
    border-left: 2px solid red;
  }

  .red-border-right {
    border-top: 2px solid red;
    border-bottom: 2px solid red;
    border-right: 2px solid red;
  }

  .label-container .text {
    font-weight: bold;
    font-size: medium;
  }

  tr {
    border-bottom: 1px solid #e0e0e0;
  }

  td {
    padding: 12px;
    text-align: left;
    vertical-align: middle;
    border-right: 1px solid #e0e0e0;
    border-left: 1px solid #e0e0e0;
  }

  tr:hover {
    background-color: #f5f5f5;
  }

  tr:nth-child(even) {
    background-color: #fafafa;
  }
</style>
